<template lang="pug">
  .input-checkbox
    v-checkbox(
      v-model="checkbox"
      :label="label"
      :disabled="disabled"
      color="success"
      row
    )
</template>

<script>
export default {
  name: 'InputCheckbox',
  props: {
    value: {
      type: Boolean,
    },
    label: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
    },
  },
  computed: {
    checkbox: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>

<style lang="stylus" scoped>
  .v-input--checkbox
    display inline-flex
    padding-right 30px
</style>
